import types from './loginTypes'

let initialState = {
    isAuthorized: false, // Авторизация в системе
    isInputClick: false, // Нажатие на кнопку войти

    myProfile: {
        login: '', // Логин оператора
        lastName: '', // Фамилия оператора
        firstName: '', // Имя оператора
        secondName: '', // Отчество оператора
        accountCreateDate: '', // Дата создания аккаунта оператора
        position: '', // Должность оператора
        avatar: '', // Аватар оператора
        phoneNumber: '', // Номер телефона оператора
        accessLevel: [] // Уровни доступа оператора
    }
}

const loginReducer = (state = initialState, action: any) => {
    switch (action.type) {
        
        // Выход из системы
        case types.LOGIN_SET_LOGOUT: {
            return {
                ...state = initialState
            }
        }

        // Авторизация в системе
        case types.LOGIN_SET_IS_AUTHORIZED: {
            return {
                ...state,
                isAuthorized: action.isAuthorized
            }
        }

        // Нажатие на кнопку войти в окне авторизации
        case types.LOGIN_SET_IS_INPUT_CLICK: {
            return {
                ...state,
                isInputClick: action.isInputClick
            }
        }

        // Получение персональных данных оператора
        case types.LOGIN_SET_MY_PROFILE: {
            return {
                ...state,
                myProfile: {
                    ...state.myProfile,
                    login: action.login,
                    lastName: action.lastName,
                    firstName: action.firstName,
                    secondName: action.secondName,
                    accountCreateDate: action.accountCreateDate,
                    position: action.position,
                    avatar: action.avatar,
                    phoneNumber: action.phoneNumber,
                    accessLevel: action.accessLevel
                }
            }
        }

        default: return state
    }
}

export default loginReducer